import type { ThemeOptions } from '@mui/material/styles';
import type { SemanticConfig } from '../types';
import { hlDarkThemeOptions } from './hypertrackerDark';
import { lightPrimitives } from '../primitives';
import { buildSemanticPalette } from '../semantic';

const resolved = lightPrimitives;
const htDarkPalette = hlDarkThemeOptions.palette as NonNullable<typeof hlDarkThemeOptions.palette>;

const semanticConfig: SemanticConfig = {
    neutral: resolved.woodsmoke,
    primary: resolved.riptide,
    success: resolved.shamrock,
    error: resolved.thunderbird,
    warning: resolved.sun,
    accent: resolved.riptide,
};

/**
 * Hypertracker light theme.
 * Shares the HT dark legacy palette/backgrounds (HT has no separate light design yet)
 * but builds its own semantic mapping from lightPrimitives.
 */
export const hlLightThemeOptions: ThemeOptions = {
    ...hlDarkThemeOptions,
    palette: {
        ...htDarkPalette,
        mode: 'light',
        primitives: resolved,
        semantic: buildSemanticPalette(semanticConfig),
    },
};
